import React, { PureComponent } from 'react'
class SplitView extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            show: false,
            children: null,
        }
        this.hide = this.hide.bind(this)
    }
    hide() {
        this.setState({
            show: false,
            children: null,
        })
    }
    show(children) {
        this.setState({
            show: true,
            children,
        })
    }
    render() {
        return (
            <div className={'splitview' + (this.state.show ? ' splitview-show' : '')} id="splitview">
                <div className="splitview-mask" onClick={this.hide} />
                <div className="splitview-box">
                    <div className="splitview-inner">
                        {this.state.children}
                        <button className="splitview-close" onClick={this.hide}>
                            <i className="icon icon-plus icon-close" />
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default SplitView
